// loggerMiddleware.ts
import { Middleware } from '@reduxjs/toolkit';
import { DatabaseLogger } from '../../services/logging/logger';

export const loggerMiddleware: Middleware = ({ dispatch, getState }) => (next) => (action: any) => {
  const logger = new DatabaseLogger();
  // log the action
  logger.log(action.type, {
    payload: action?.payload,
    meta: action.meta,
  });

  const result = next(action);

  return result;
};
